import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import * as ReqType from '../../types/ServerRequests';
import { InfoProfile } from './internalComponents/InfoProfile';
import { CoursProfile } from './internalComponents/CoursProfile';
import { MediaProfile } from './internalComponents/MediaProfile';
import './internalComponents/Profile.css';
import { ListFrais } from './internalComponents/ListFrais';
import { ListeEvent } from './internalComponents/ListeEvent';
import LoginServices from '../../services/LoginServices';
import { DocumentsProfile } from './internalComponents/DocumentsProfile';
import { UserService } from '../../services/UserService';
import { ModifMdpProfile } from './internalComponents/ModifMdpProfile';
import { EventService } from '../../services/EventService';
import { MediaService } from '../../services/MediaService';

interface State {
    profil?: ReqType.UserView;
    frais: ReqType.Frais[];
    cours: ReqType.Course[];
    evenements: ReqType.Event[];
    photoProfile: string;

}

interface Props {

}

/**
 * Ce composant permet d'afficher de la page de profile
 */
export class ProfilePage extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
            frais: [],
            cours: [],
            evenements: [],
            photoProfile: require('./internalComponents/photoProfile.PNG')
        };
        const userType = LoginServices.getInstance().getType();
        this.getProfil();
        if (userType === UserRole.ADMIN.toString() ||
            userType === UserRole.SEMI_PRO.toString()) {
            this.getFees();
        }
        if (userType === UserRole.ADMIN.toString() ||
            userType === UserRole.SEMI_PRO.toString() ||
            userType === UserRole.MEMBER.toString()) {
            this.getEvents();
        }
        // this.getPhotoProfile();
        this.getCourses();
    }

    /*public getPhotoProfile(): void {
        const userId = LoginServices.getInstance().getUserId();
        if (userId !== undefined) {
            UserService.getInstance().getUser(userId).then(
                (response: ReqType.UserView) => {
                    // alert(response.userProfile!.photo_profil);
                    if (response.userProfile!.photo_profil === '') {
                        this.setState({ photoProfile: require('./internalComponents/photoProfile.PNG') });
                    } else {
                        this.setState({
                            photoProfile: MediaService.getInstance().getBaseURL() +
                                response.userProfile!.photo_profil
                        });
                        console.warn(this.state.photoProfile);
                    }
                }).catch(
                    (error) => {
                        // alert(error);
                    }
                );
        }
    }*/

    public getEvents(): void {
        const userId = LoginServices.getInstance().getUserId();
        if (userId !== undefined) {
            EventService.getInstance().getEvents().then(
                (resp: ReqType.Event[]) => {
                    this.setState({ evenements: resp });
                }
            ).catch(
                () => {
                    // alert('Le service marche pas')
                }
            );
        }
    }

    public getCourses(): void {
        const userId = LoginServices.getInstance().getUserId();
        if (userId !== undefined) {
            UserService.getInstance().getUserCourses(userId).then(
                (response: ReqType.Course[] | string) => {
                    if (response !== '') {
                        this.setState({ cours: response });
                    }
                }
            ).catch(
                (error) => {
                    // alert(error);
                }
            );
        }
    }

    public getFees(): void {
        const userId = LoginServices.getInstance().getUserId();
        if (userId !== undefined) {
            UserService.getInstance().getUserFees(userId).then(
                (response: ReqType.Frais[]) => {
                    // alert('Profile loaded');
                    this.setState({ frais: response });
                }
            ).catch(
                (error) => {
                    // alert(error);
                }
            );
        }
    }

    public getProfil(): void {
        const userId = LoginServices.getInstance().getUserId();
        if (userId !== undefined) {
            UserService.getInstance().getUser(userId).then(
                (response: ReqType.UserView) => {
                    // alert('Profile loaded');
                    if (response.userProfile === null ||
                        response.userProfile.photo_profil === null
                    ) {
                        this.setState({ 
                            photoProfile: require('./internalComponents/photoProfile.PNG'),
                            profil: response
                        });
                    } else {
                        this.setState({
                            photoProfile: MediaService.getInstance().getBaseURL() +
                                response.userProfile!.photo_profil,
                            profil: response
                        });
                    }
                    this.setState({ profil: response });
                }
            ).catch(
                (error) => {
                    // alert(error);
                }
            );
        }
    }

    render() {
        var infoProfil = undefined;
        if (this.state.profil !== undefined) {
            infoProfil = (
                <div className="col-12 rounded">
                    <InfoProfile
                        information={this.state.profil}
                        changeProfile={
                            (e: ReqType.UserView) => {
                                this.setState({ profil: e });
                            }
                        }
                    />
                </div>
            );
        }
        var nom: string = '';
        if (this.state.profil !== null && this.state.profil !== undefined) {
            if (this.state.profil.userProfile !== null && this.state.profil.userProfile !== undefined) {
                nom = this.state.profil.userProfile!.nom + ' ' + this.state.profil.userProfile!.prenom;
            }
        } else {
            nom = '';
        }
        const userRole = LoginServices.getInstance().getType();

        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.USER,
                    UserRole.SEMI_PRO,
                    UserRole.ADMIN,
                    UserRole.MEMBER,
                ]}
            >
                <div style={{ paddingTop: '10px' }}>
                    <div className=" margin-top">
                        <img
                            src={this.state.photoProfile}
                            className="img-thumbnail mx-auto d-block rounded-circle"
                            alt="Photo de profil"
                            width="200"
                            height="200"
                        />
                        <h1 className="text-center">
                            {nom}
                        </h1>
                    </div>
                    {infoProfil}

                    <div className="col-12">
                        <ModifMdpProfile />
                    </div>

                    <div className="col-12">
                        {this.state.profil === undefined ? undefined :
                            <DocumentsProfile user_id={this.state.profil.id.toString()} hidden={false} />
                        }
                    </div>

                    <div className="col-12">
                        <CoursProfile cours={this.state.cours} />
                    </div>
                    {
                        (
                            userRole === undefined ||
                            userRole === UserRole.USER.toString() ||
                            userRole === UserRole.NOT_LOGED_IN.toString()
                        ) ?
                            undefined :
                            (
                                <div className="col-12">
                                    <div className="col-12">
                                        {this.state.profil === undefined ? undefined :
                                            <ListeEvent listEvent={this.state.profil.events} />
                                        }
                                    </div>

                                    {userRole === UserRole.MEMBER.toString() ? undefined : (
                                        <div className="col-12">
                                            <ListFrais frais={this.state.frais} />
                                        </div>
                                    )}

                                </div>
                            )
                    }
                    <div className="col-12" style={{ paddingBottom: '20px' }}>
                        <MediaProfile
                            media={
                                this.state.profil === undefined ? [] : this.state.profil.media
                            }
                            displayControls={true}
                            setMedia={
                                (m: ReqType.Media[]) => {
                                    if (this.state.profil !== undefined) {
                                        var profile = UserService
                                            .getInstance()
                                            .duplicateUserView(this.state.profil);
                                        profile.media = m;
                                        this.setState({ profil: profile });
                                    }
                                }
                            }
                        />
                    </div>
                </div>
            </PageChorinitia>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/ProfilePage.tsx